import React from 'react';

import ProductList from './../Products/Product-List'
import About from './About'
import Contact from './Contact'

const Home = ()=>{
	return(
		<React.Fragment>
			<ProductList title="Shop Now" id="shop" />
			<About id="about" />
			<Contact id="contact" />
		</React.Fragment>
	)
}

export default Home;